import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-download-redirect',
  template: '',
})
export class appDownloadComponent {

    constructor(private router: Router) {}

    redirectToExternalUrl(url: string): void {
    this.router.navigate(['/externalRedirect'], { queryParams: { target: url } });
    }
}